class PasswordModal extends HTMLElement {

  constructor() {
    super();
    // Selectors
    this.modalOpenClass = 'password-modal-open';
    this.openModalButton = this.querySelector('[data-password-modal-open]');
    this.closeModalButton = this.querySelector('[data-password-modal-close]');
    // Listeners
    document.body.addEventListener('keyup', (event) => event?.code.toUpperCase() === 'ESCAPE' && this.close());
    this.openModalButton?.addEventListener('click', () => this.open());
    this.closeModalButton?.addEventListener('click', () => this.close());
  }

  onBodyClick(event) {
    if (!this.contains(event.target)) this.close(false);
  }

  open() {
    document.body.classList.add(this.modalOpenClass);
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    document.body.addEventListener('click', this.onBodyClickEvent);
    trapFocus(this.querySelector('[data-password-modal-content]'), this.querySelector('#Password'));
  }

  close() {
    document.body.classList.remove(this.modalOpenClass);
    document.body.removeEventListener('click', this.onBodyClickEvent);
    removeTrapFocus();
  }
}

if (!customElements.get('password-modal')) {
  customElements.define('password-modal', PasswordModal);
}
